<ng-template #template>
    <div class="modal-container">
        <div class="modal-body">
            <bs-datepicker-inline [minDate]="minDate" [bsValue]="bsValue" [bsConfig]="bsConfig" (bsValueChange)="selectDate($event)" />
        </div>
    </div>
</ng-template>